import React from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Gear, SignOut } from '@phosphor-icons/react';
import { cn } from '@/lib/utils';

export default function UserMenu({
  sidebarCollapsed,
  initials,
  user,
  navigate,
  handleLogout,
}) {
  const firstName = (user?.name || '').split(' ')[0] || 'User';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className={cn(
            'w-full flex items-center rounded-lg hover:bg-muted transition-colors',
            sidebarCollapsed ? 'justify-center p-2' : 'gap-2.5 px-2.5 py-2',
          )}
          data-testid="user-menu-trigger"
        >
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#1a1a1f] to-[#2a2a30] flex items-center justify-center text-[11px] font-bold text-[#c4a44a] shrink-0 border border-[#c4a44a]/20">
            {initials}
          </div>
          {!sidebarCollapsed && (
            <span className="flex-1 text-left text-[11px] font-semibold truncate">{firstName}</span>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align={sidebarCollapsed ? 'center' : 'end'} side={sidebarCollapsed ? 'right' : 'top'} className="w-48">
        <div className="px-3 py-2 border-b border-border mb-1">
          <p className="text-xs font-semibold truncate">{user?.name}</p>
          <p className="text-[10px] text-muted-foreground truncate">{user?.email}</p>
        </div>
        <DropdownMenuItem onClick={() => navigate('/settings')} data-testid="menu-settings">
          <Gear size={14} className="mr-2" />
          Settings
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleLogout} className="text-destructive" data-testid="menu-logout">
          <SignOut size={14} className="mr-2" />
          Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
